// Signup writes this exact string; the terminal resolves it to the crypto layout.
// Keep in sync with the post-confirmation lambda and open-market user creation.
export const CRYPTO_TAB_PRESET_CONFIGURATION = '{"preset":"crypto"}';

export const isCryptoTabPresetConfiguration = (
  configuration: string | null | undefined,
): boolean => configuration === CRYPTO_TAB_PRESET_CONFIGURATION;
